import {
	createMemberAttribute200Schema,
	createMemberAttributeMutationRequestSchema,
	deleteMemberAttribute200Schema,
	deleteMemberAttributePathParamsSchema,
	listMemberAttributes200Schema,
	listMemberAttributesQueryParamsSchema,
	updateMemberAttribute200Schema,
	updateMemberAttributeMutationRequestSchema,
	updateMemberAttributeOrder200Schema,
	updateMemberAttributeOrderMutationRequestSchema,
	updateMemberAttributePathParamsSchema,
} from "../schemas/memberAttributeApi.schemas";
import type {
	CreateMemberAttribute200Response,
	DeleteMemberAttribute200Response,
	ListMemberAttributes200Response,
	UpdateMemberAttribute200Response,
	UpdateMemberAttributeOrder200Response,
} from "../types/memberAttributeApi.types";

/**
 * Shared endpoint contract configuration
 * This ensures both client and server use the same endpoint definitions
 */
export const memberAttributeEndpointContract = {
	listMemberAttributes: {
		path: "/member-attributes",
		method: "GET",
		querySchema: listMemberAttributesQueryParamsSchema,
		responseSchema: listMemberAttributes200Schema,
		responseType: {} as ListMemberAttributes200Response,
	},
	createMemberAttribute: {
		path: "/member-attributes",
		method: "POST",
		bodySchema: createMemberAttributeMutationRequestSchema,
		responseSchema: createMemberAttribute200Schema,
		responseType: {} as CreateMemberAttribute200Response,
	},
	updateMemberAttribute: {
		path: "/member-attributes/:memberAttributeId",
		method: "PUT",
		paramsSchema: updateMemberAttributePathParamsSchema,
		bodySchema: updateMemberAttributeMutationRequestSchema,
		responseSchema: updateMemberAttribute200Schema,
		responseType: {} as UpdateMemberAttribute200Response,
	},
	updateMemberAttributeOrder: {
		path: "/member-attributes/order",
		method: "PUT",
		bodySchema: updateMemberAttributeOrderMutationRequestSchema,
		responseSchema: updateMemberAttributeOrder200Schema,
		responseType: {} as UpdateMemberAttributeOrder200Response,
	},
	deleteMemberAttribute: {
		path: "/member-attributes/:memberAttributeId",
		method: "DELETE",
		paramsSchema: deleteMemberAttributePathParamsSchema,
		responseSchema: deleteMemberAttribute200Schema,
		responseType: {} as DeleteMemberAttribute200Response,
	},
} as const;
